/**
 * 标签设置的搜索框列表
 */
export function getRoomAttributSearchData(configList) {
    let datayear = new Date().getFullYear().toString()
    return [
        { name: "姓名/专业", type: "input-search", value: "", key: "name" },
        { name: "学校", type: "select", value: "", key: "school", options: configList.schoolList },
        {
            name: "审核状态",
            type: "select-noclean",
            value: "4",
            key: "status",
            options: [{
                    label: '全部',
                    value: '4'
                },
                {
                    label: '通过',
                    value: '2'
                }, {
                    label: '不通过',
                    value: '3'
                },
            ]
        },
        { name: "报考专业", type: "select", value: "", key: "readyProfession", options: configList.professionList },
        {
            name: "鼓励政策",
            type: "select",
            value: "",
            key: "specialFlag",
            options: [
                { label: "非鼓励政策", value: "非鼓励政策" },
                { label: "鼓励政策（免试或面试）", value: "免试" },
                { label: "鼓励政策（加分）", value: "加分" },
            ]
        },
        { name: "年", type: "year", value: datayear, key: "year" },
    ]
}

/**
 * 标签类别列表
 */
export function getAttributeType() {
    return [
        { label: "专业", value: "计算机" },
    ]
}

/**
 * 获取标签设置的表格表头
 */
export function getAttributeMenu() {
    return [
        { key: "name", name: "姓名", sortable: false, width: 90, },
        { key: "sex", name: "性别", sortable: false, width: 60, },
        { key: "stuNum", name: "考生号", sortable: false, width: 180, },
        { key: "volunteerType", name: "志愿类别", sortable: false, width: 220 },
        { key: "readyProfession", name: "考生志愿", sortable: false, width: 220 },
        { key: "school", name: "毕业院校", sortable: false, width: 220, },
        { key: "profession", name: "毕业专业", sortable: false, width: 220, },
        { key: "phone", name: "联系电话", sortable: false, width: 120, },
        { key: "contact", name: "紧急联系人", sortable: false, width: 120, },
        // { key: "stuStatusNum", name: "中职学籍号", sortable: false, width: 220 },
        // { key: "nation", name: "民族", sortable: false, width: 110, },
        // { key: "political", name: "政治面貌", sortable: false, width: 110, },
        { key: "idCard", name: "身份证号", sortable: false, width: 200 },
        { key: "address", name: "家庭住址", sortable: false, width: 200 },
    ]
}

/**
 * 将标签类别名称转换成对应的value
 */
export function changeLabelToValue(label) {
    let list = getAttributeType()
    let value = ""
    list.forEach(element => {
        if (element.label == label) {
            value = element.value
        }
    });
    return value
}

/**
 * 个人信息
 */
export function getpeopleinfo() {
    return [{
        name: "考生号",
        type: "text",
        value: "",
        key: "stuNum",
    },{
            name: "姓名",
            type: "text",
            value: "",
            key: "name",
        }, {
            name: "性别",
            type: "text",
            value: "",
            key: "sex",
        }, {
            name: "科类	",
            type: "text",
            value: "",
            key: "studyType",
        },   {
            name: "身份证号",
            type: "text",
            value: "",
            key: "idCard",
        }, 
        {
            name: "投档段类	",
            type: "text",
            value: "",
            key: "portfolioCategory",
        }, {
            name: "考试志愿",
            type: "text",
            value: "",
            key: "readyProfession",
        },
        {
            name: "志愿类别",
            type: "text",
            value: "",
            key: "volunteerType",
        },{
            name: "毕业院校",
            type: "text",
            value: "",
            key: "school",
        },{
            name: "毕业专业",
            type: "text",
            value: "",
            key: "profession",
        }, {
            name: "联系电话",
            type: "text",
            value: "",
            key: "phone",
        },{
            name: "紧急联系人",
            type: "text",
            value: "",
            key: "contact",
        }, {
            name: "家庭住址",
            type: "text",
            value: "",
            key: "address",
        },
        {
            name: "报名材料",
            // type: "icon",
            type: "fileOrIcon",
            value: [],
            key: "proveFile",
        },{
            name: "审核结果",
            type: "text",
            value: "",
            key: "status",
        }, {
            name: "不通过原因",
            type: "text",
            value: "",
            key: "refuseReason",
        }, {
            name: "审核时间",
            type: "text",
            value: "",
            key: "checkTime",
        }, {
            name: "审核人	",
            type: "text",
            value: "",
            key: "checkUser",
        },

    ]
}
